// Chrome iOS runs Google Translate's element script through WKWebView evaluateJavaScript, so JavaScriptCore reports
// the document URL as its filename and Sentry shows page markup as source context. Our own inline snippets share that
// filename, hence the class marker and the error class as extra conditions; a frame from any served script keeps the event.
// See docs/bug-analyzes/2026-09-07 RangeError from Chrome iOS Google Translate.md
const TRANSLATED_CLASSES = ['translated-ltr', 'translated-rtl'];
const FILENAMES_WITHOUT_LOCATION = ['[native code]', '<anonymous>'];
const STACK_OVERFLOW_MESSAGE = /Maximum call stack size exceeded/;

function withoutQueryAndHash(url) {
	return url.split('#')[0].split('?')[0];
}

function isTranslatedByGoogle() {
	return [document.documentElement, document.body].some((element) =>
		Boolean(element && element.classList) && TRANSLATED_CLASSES.some((className) => element.classList.contains(className))
	);
}

export default function isErrorFromGoogleTranslate(event) {
	const values = (event.exception && event.exception.values) || [];
	if (!isTranslatedByGoogle() || !values.some((value) => STACK_OVERFLOW_MESSAGE.test(value.value || ''))) {
		return false;
	}
	const locatedFrames = [];
	values.forEach((value) => {
		((value.stacktrace && value.stacktrace.frames) || []).forEach((frame) => {
			if (typeof frame.filename === 'string' && frame.filename && !FILENAMES_WITHOUT_LOCATION.includes(frame.filename)) {
				locatedFrames.push(frame);
			}
		});
	});
	if (!locatedFrames.length) {
		return false;
	}
	const documentUrl = withoutQueryAndHash(window.location.href);
	return locatedFrames.every((frame) => withoutQueryAndHash(frame.filename) === documentUrl);
}
